import { ChevronRightIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useGetSettings } from "src/api/General/settings";
import {
  SpaceData,
  useDeleteSpace,
  useGetSpace,
  useUpdateSpace,
} from "src/api/Spaces/spaces";
import { Loading } from "src/components/ui/loading";
import { Switch } from "src/components/ui/switch";
import { TextInput } from "src/components/ui/text-input";
import { SpaceNameAndSymbol } from "src/pages/spaces/spaces";

type Props = {};

export default function SpaceAppsSettings({}: Props) {
  const { spaceId } = useParams();
  const { data: space } = useGetSpace(String(spaceId));
  const { data: settings } = useGetSettings();
  const [deletingOpen, setDeletingOpen] = useState(false);
  const deleteSpaceMutation = useDeleteSpace();
  const [deleteConfirmationText, setDeleteConfirmationText] = useState("");
  useEffect(() => {
    if (deleteSpaceMutation.isSuccess) {
      setDeletingOpen(false);
    }
  }, [deleteSpaceMutation.isSuccess]);

  const updateSpaceMutation = useUpdateSpace();

  return (
    <div>
      <div className="flex h-12 items-center border-b border-gray-200/70 px-8">
        <div className="flex items-center space-x-2 text-sm">
          <Link to={`/settings/spaces/${spaceId}`}>
            {space && (
              <SpaceNameAndSymbol name={space.name} color={space.color} />
            )}
          </Link>
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <div className="cursor-default text-gray-800">{"Apps"}</div>
        </div>
      </div>
      <div className="mx-auto max-w-2xl pt-20">
        <div>
          <div className="border-b border-gray-200/70 pb-6 text-xl font-medium">
            Apps
          </div>
          {!!space && !!settings ? (
            <>
              {settings?.apps.timeTracking.isEnabled && <div className="flex items-center justify-between pt-8">
                <div className="space-y-0.5">
                  <div className="font-medium text-gray-800">Time Tracking</div>
                  <div className="text-sm font-light text-gray-600">
                    Enabling time tracking will allow you to track time spent on
                    projects in this space. If disabled, projects from this
                    space will not show up in the time tracking dropdowns or
                    analytics.
                  </div>
                </div>
                <Switch
                  checked={space.settings?.timeTracking}
                  onCheckedChange={(checked) => {
                    updateSpaceMutation.mutate({
                      _id: space._id,
                      settings: {
                        timeTracking: !!checked,
                      },
                    });
                  }}
                />
              </div>}
              {/* {settings?.apps.resourceManagement.isEnabled && <div className="flex items-center justify-between pt-8">
                <div className="space-y-0.5">
                  <div className="font-medium text-gray-800">
                    Resource Management
                  </div>
                  <div className="text-sm font-light text-gray-600">
                    Manage your team's allocation of time across projects.
                  </div>
                </div>
                <Switch
                  checked={space.settings?.resourceManagement}
                  onCheckedChange={(checked) => {
                    updateSpaceMutation.mutate({
                      _id: space._id,
                      settings: {
                        resourceManagement: !!checked,
                      },
                    });
                  }}
                />
              </div>} */}
              {settings?.apps.billing.isEnabled && <div className="flex items-center justify-between pt-8 pb-8">
                <div className="space-y-0.5">
                  <div className="font-medium text-gray-800">Billing</div>
                  <div className="text-sm font-light text-gray-600">
                    Enabling billing will allow you to capture billing in
                    projects.
                  </div>
                </div>
                <Switch
                  checked={space.settings?.billing}
                  onCheckedChange={(checked) => {
                    updateSpaceMutation.mutate({
                      _id: space._id,
                      settings: {
                        billing: !!checked,
                      },
                    });
                  }}
                />
              </div>}
              {/* <div className="flex items-center justify-between border-b border-gray-200/70 pt-8 pb-8">
                <div className="space-y-0.5">
                  <div className="font-medium text-gray-800">Billing</div>
                  <div className="text-sm font-light text-gray-600">
                    Enabling time tracking will allow you to track time spent on
                    projects in this space. If disabled, projects from this
                    space will not show up in the time tracking dropdowns or
                    analytics.
                  </div>
                </div>
                <Switch />
              </div> */}
            </>
          ) : (
            <Loading className="mt-20" />
          )}
        </div>
      </div>
    </div>
  );
}

function SpaceName({ space }: { space: SpaceData }) {
  const [name, setName] = useState(space.name);
  const updateSpaceMutation = useUpdateSpace();
  return (
    <TextInput
      className="w-72"
      value={name}
      onChange={(e) => {
        setName(e.target.value);
      }}
      onBlur={() => {
        if (name.trim() !== space.name.trim()) {
          updateSpaceMutation.mutate({
            _id: space._id,
            name: name,
          });
        }
      }}
    />
  );
}
